"use client";

import Image from "next/image";

export default function CampusGallery({
    mainLeftImages,
    mainRightImage,
    gridImages,
}) {
    const imageWrapperClasses =
        "relative overflow-hidden w-full aspect-[4/3] aspect-auto";

    return (
        <section className="w-full bg-white ">
            <div>
                <div className="flex flex-col lg:flex-row gap-4">
                    <div className="flex flex-row gap-4 lg:w-[45%]">
                        <div className="flex flex-col gap-4 flex-1">
                            <div className="relative w-full aspect-[4/3] overflow-hidden">
                                <Image
                                    src={mainLeftImages[0].src}
                                    alt={mainLeftImages[0].alt}
                                    fill
                                    className="object-cover"
                                />
                            </div>
                            <div className="relative w-full aspect-[4/3] overflow-hidden">
                                <Image
                                    src={mainLeftImages[1].src}
                                    alt={mainLeftImages[1].alt}
                                    fill
                                    className="object-cover"
                                />
                            </div>
                            <div className="relative w-full aspect-[4/3] overflow-hidden">
                                <Image
                                    src={mainLeftImages[2].src}
                                    alt={mainLeftImages[2].alt}
                                    fill
                                    className="object-cover"
                                />
                            </div>
                        </div>

                        <div className="flex flex-col gap-4 flex-1">
                            <div className="relative w-full aspect-[4/3] overflow-hidden">
                                <Image
                                    src={mainLeftImages[3].src}
                                    alt={mainLeftImages[3].alt}
                                    fill
                                    className="object-cover"
                                />
                            </div>
                            <div className="relative w-full aspect-[4/3] overflow-hidden">
                                <Image
                                    src={mainLeftImages[4].src}
                                    alt={mainLeftImages[4].alt}
                                    fill
                                    className="object-cover"
                                />
                            </div>
                            <div className="relative w-full aspect-[4/3] overflow-hidden">
                                <Image
                                    src={mainLeftImages[5].src}
                                    alt={mainLeftImages[5].alt}
                                    fill
                                    className="object-cover"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="relative lg:w-[55%] w-full aspect-[16/7] overflow-hidden">
                        <Image
                            src={mainRightImage.src}
                            alt={mainRightImage.alt}
                            fill
                            className="object-cover"
                        />
                    </div>
                </div>
            </div>

            <div className="mt-4">
                <div
                    className="grid md:grid-cols-6 md:grid-rows-3 gap-4 sm:gap-4 w-full"
                    style={{ aspectRatio: "16 / 9" }}
                >
                    <div
                        className={`${imageWrapperClasses} col-span-2 row-span-1`}
                        style={{ gridColumnStart: 1, gridRowStart: 1 }}
                    >
                        <Image
                            src={gridImages[0].src}
                            alt={gridImages[0].alt}
                            fill
                            className="object-cover"
                        />
                    </div>

                    <div className={imageWrapperClasses}>
                        <Image
                            src={gridImages[1].src}
                            alt={gridImages[1].alt}
                            fill
                            className="object-cover"
                        />
                    </div>
                    <div className={imageWrapperClasses}>
                        <Image
                            src={gridImages[2].src}
                            alt={gridImages[2].alt}
                            fill
                            className="object-cover"
                        />
                    </div>

                    <div
                        className={`${imageWrapperClasses} col-span-2 row-span-2`}
                        style={{ gridColumnStart: 3, gridRowStart: 1 }}
                    >
                        <Image
                            src={gridImages[3].src}
                            alt={gridImages[3].alt}
                            fill
                            className="object-cover"
                        />
                    </div>

                    <div className={imageWrapperClasses}>
                        <Image
                            src={gridImages[4].src}
                            alt={gridImages[4].alt}
                            fill
                            className="object-cover"
                        />
                    </div>
                    <div className={imageWrapperClasses}>
                        <Image
                            src={gridImages[5].src}
                            alt={gridImages[5].alt}
                            fill
                            className="object-cover"
                        />
                    </div>
                    <div className={imageWrapperClasses}>
                        <Image
                            src={gridImages[6].src}
                            alt={gridImages[6].alt}
                            fill
                            className="object-cover"
                        />
                    </div>

                    <div className={imageWrapperClasses}>
                        <Image
                            src={gridImages[7].src}
                            alt={gridImages[7].alt}
                            fill
                            className="object-cover"
                        />
                    </div>

                    <div
                        className={`${imageWrapperClasses} col-span-2 row-span-1`}
                        style={{ gridColumnStart: 1, gridRowStart: 3 }}
                    >
                        <Image
                            src={gridImages[8].src}
                            alt={gridImages[8].alt}
                            fill
                            className="object-cover"
                        />
                    </div>

                    <div className={imageWrapperClasses}>
                        <Image
                            src={gridImages[9].src}
                            alt={gridImages[9].alt}
                            fill
                            className="object-cover"
                        />
                    </div>
                    <div className={imageWrapperClasses}>
                        <Image
                            src={gridImages[10].src}
                            alt={gridImages[10].alt}
                            fill
                            className="object-cover"
                        />
                    </div>

                    <div
                        className={`${imageWrapperClasses} col-span-2 row-span-1`}
                        style={{ gridColumnStart: 5, gridRowStart: 3 }}
                    >
                        <Image
                            src={gridImages[11].src}
                            alt={gridImages[11].alt}
                            fill
                            className="object-cover"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
